import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Download',
				id: 'historicalCsvDownload',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.staticSegments,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].downloadHistoricalCsv,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
